'use client';

import { useState } from 'react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (event : React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus('loading');

    try {
      const res = await fetch('/api/subscribes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus(data.error || 'error');
      }
    } catch (err) {
      console.log(err);
      setStatus('error');
    }
  };

  return (
    <form className="domain_search" onSubmit={handleSubmit}>
      <div className="input-group my-3 p-2 bg-white rounded-3">
        <input
          type="email"
          className="form-control form-control-lg"
          placeholder="Enter Email to stay Tuned"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button className="btn btn-primary btnfill0" type="submit">
          Sign Up
        </button>
      </div>
      {status === 'success' && <p className="text-success">You are subscribed!</p>}
      {status && status !== 'success' && status !== 'loading' && (
        <p className="text-danger">{status}</p>
      )}
    </form>
  );
}
